/** 目前仅适用于中航电测 */
import React from "react";

export function SpecialTips(props:{quotecode:string}) {
  let date = new Date().getTime()
  let endDate =  new Date('2025/2/24 23:59:59').getTime()
  let diff = endDate - date

  return <>
    {
      diff > 0 && props.quotecode == "302132" && <div className="special-tips">
      应交易所要求，中航电测（证券代码：300114）的证券简称、证券代码将于2025年2月17日起变更为中航成飞（证券代码：302132）
    </div>
    }
  </>
}
